import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { PiSpinnerBold } from 'react-icons/pi'

const Container = styled.div`
  position: fixed;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${size(1)} ${size(1.75)};
  border-radius: 100px;
  z-index: 100;
  border: 0.5px solid rgba(255,255,255, 0.15);

  background-color: rgba(65,65,65,0.85);
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);

  letter-spacing: 0.5px;
  white-space: nowrap;
  font-weight: bold;
  font-size: ${fontSize('xs')};
  // color: ${colors.statusColors['right_now']('light')};
`

const NearbyProfilesLoading = ({ profilesInitialized, isProfilesReloading, shouldReauthWebsocket, isReconnecting }) => {

  const renderText = () => {
    if (isProfilesReloading) {
      return 'Refreshing Profiles'
    } else if (isReconnecting) {
      return 'Reconnecting'
    } else if (shouldReauthWebsocket) {
      return 'Disconnected'
    }
  }

  // Short circuit until we load the initial map data
  if (!profilesInitialized) return;

  // Render message for any of the given states
  if (isProfilesReloading || shouldReauthWebsocket || isReconnecting) {
    return (
      <Container>
          <PiSpinnerBold
            size={size(1.75)}
            strokeWidth={size(1.25)}
            className='animation_rotation'
          />
          &nbsp;&nbsp;{renderText()}
      </Container>
    )
  }
}

export { NearbyProfilesLoading }
